import { render, staticRenderFns } from "./UniversalFooter.vue?vue&type=template&id=9167dea0&scoped=true"
import script from "./UniversalFooter.vue?vue&type=script&lang=js"
export * from "./UniversalFooter.vue?vue&type=script&lang=js"
import style0 from "./UniversalFooter.vue?vue&type=style&index=0&id=9167dea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9167dea0",
  null
  
)

export default component.exports